(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facebook-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class FbReviewsSlider {
    constructor(container) {
      this.container  = container;
      this.slides     = Array.from(container.querySelectorAll('.fb-reviews__slide'));
      this.dots       = Array.from(container.querySelectorAll('.fb-reviews__dot'));
      this.autoplay   = container.dataset.autoplay === 'true';
      this.speed      = parseInt(container.dataset.speed, 10) || 4000;
      this.current    = 0;
      this.timer      = null;

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i));
      });

      if (this.autoplay) this.startTimer();

      // Pause on hover / focus
      container.addEventListener('mouseenter', () => this.stopTimer());
      container.addEventListener('mouseleave', () => { if (this.autoplay) this.startTimer(); });
      container.addEventListener('focusin',    () => this.stopTimer());
      container.addEventListener('focusout',   () => { if (this.autoplay) this.startTimer(); });
    }

    goTo(index) {
      if (index === this.current) return;
      this.slides[this.current].classList.remove('is-active');
      this.dots[this.current]?.classList.remove('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'false');

      this.current = (index + this.slides.length) % this.slides.length;

      this.slides[this.current].classList.add('is-active');
      this.dots[this.current]?.classList.add('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'true');
    }

    next() {
      this.goTo(this.current + 1);
    }

    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => this.next(), this.speed);
    }

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[id^="fb-reviews-"]').forEach(el => {
      if (!el._fbReviewsInit) {
        el._fbReviewsInit = true;
        new FbReviewsSlider(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor live reload support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[id^="fb-reviews-"]');
    if (section) {
      section._fbReviewsInit = false;
      new FbReviewsSlider(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
